"use strict";

/*==============================================================================
TRESTLE™ W004
POPUP TOOL — PERIMENOPAUSE SELF-CHECK
==============================================================================*/

window.TRESTLE_W004_TOOLS =
    window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.perimenopause_self_check = {


/*==============================================================================
RENDER
==============================================================================*/

    render(){

        return `

        <div class="tr-w004-peri-tool">

            <div class="peri-check-card">

                <div class="peri-check-subtitle">
                    Are You Experiencing?
                </div>


                <div class="peri-check-grid">


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Irregular Periods
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Hot Flashes
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Night Sweats
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Weight Gain
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Sleep Problems
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Mood Changes
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Brain Fog
                        </div>

                    </div>


                    <div class="peri-check-item">

                        <div class="peri-check-icon">
                            ✓
                        </div>

                        <div class="peri-check-text">
                            Unexplained Blood Sugar Fluctuations
                        </div>

                    </div>


                </div>


                <div class="peri-check-note">

                    <strong>
                        Several symptoms sound familiar?
                    </strong>

                    <br>

                    Hormonal changes associated with perimenopause may be
                    contributing to what you're experiencing. Consider
                    discussing your symptoms with a qualified healthcare
                    professional for appropriate evaluation and guidance.

                </div>

            </div>

        </div>

        `;

    },


/*==============================================================================
INIT
==============================================================================*/

    init(){

        /* Informational tool — no interaction required. */

    }

};